<template>
  <div class="mypage-favorite-player-init-select-pane">
    <player-select-list-section
      :listData="players"
      :selectedID="selectedID"
      @selectChange="changeSelected"
    />
    <action-buttons-section
      class="mypage-favorite-player-init-select-pane__action-buttons"
      scrollTargetSelector=".mypage-favorite-player-init-select-page__content"
      :visible="true"
    >
      <atom-input-button
        :linkText="$tc('common.set')"
        :isDisabled="false"
        @push="changeFavoritePlayer"
      />
    </action-buttons-section>
  </div>
</template>

<script lang="ts">
import { defineComponent, Ref } from '@vue/composition-api'
import PlayerSelectListSection from '@/components/MypageFavoritePlayerSelectPage/MypageFavoritePlayerSelectPane/PlayerSelectListSection.vue'
import ActionButtonsSection from '@/components/common/form/ActionButtonsSection.vue'
import AtomInputButton from '@/components/atoms/input/AtomInputButton.vue'
import StoreUtil from '@/store/StoreUtil'
import PlayerDocument from '@/store/stores/collectionModule/documents/player/PlayerDocument'

export type DataType = {
  selectedID: string
}

/**
 * マイページ: お気に入り選手変更 コンテンツペイン
 */
export default defineComponent({
  name: 'MypageFavoritePlayerInitSelectPane',
  components: {
    PlayerSelectListSection,
    ActionButtonsSection,
    AtomInputButton,
  },
  data(): DataType {
    return {
      /**
       * セレクトID
       */
      selectedID: '',
    }
  },
  setup() {
    const mypagePageStore = StoreUtil.useStore('MypagePageStore')

    return {
      players: mypagePageStore.addedSelectLaterAvailablePlayers as Ref<PlayerDocument[]>,
      savingFavoritePlayer: mypagePageStore.savingFavoritePlayer,
      setSavingFavoritePlayerId: mypagePageStore.setSavingFavoritePlayerId,
    }
  },
  mounted() {
    this.selectedID = this.savingFavoritePlayer ? this.savingFavoritePlayer.sid : ''
  },
  methods: {
    changeFavoritePlayer() {
      /**
       * 選択したお気に入り選手をストアに保存
       */
      this.setSavingFavoritePlayerId(this.selectedID)

      this.$emit('changed')
    },
    changeSelected(selectedItemID: string): void {
      /**
       * 選択変更
       * @param selectedItemID : string
       */
      this.selectedID = this.selectedID === selectedItemID ? '' : selectedItemID
    },
  },
})
</script>

<style lang="scss" scoped>
.mypage-favorite-player-init-select-pane {
  width: 100%;
  max-width: $responsiveMypageMaxWidth;
  height: calc(#{$mypageContentHeightHasSubHeader} - #{env(safe-area-inset-bottom)});
  padding: 24px 0 104px;
  margin: 0 auto;
  text-align: center;
  overflow-y: auto;
  overflow-x: hidden;

  &__action-buttons {
    bottom: 0;
  }
}
</style>
